var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{on:{"click":function($event){_vm.gotoQuestion()}}},[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(_vm.name))]),_c('td',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }